"use strict";
function messageOf(err) {
  if (err instanceof Error) {
    const cause = err.cause;
    const causeMsg = cause instanceof Error ? ` ${cause.message}` : "";
    return `${err.message}${causeMsg}`.toLowerCase();
  }
  return String(err).toLowerCase();
}
export function isPaymasterFailure(err) {
  const msg = messageOf(err);
  if (/aa3[0-6]\b/.test(msg)) {
    return true;
  }
  if (/-3250[1345]\b/.test(msg)) {
    return true;
  }
  return msg.includes("paymaster") && (msg.includes("deposit") || msg.includes("policy") || msg.includes("limit") || msg.includes("quota") || msg.includes("sponsor") || msg.includes("rejected") || msg.includes("reverted") || msg.includes("balance"));
}
export function isUserExecutionFailure(err) {
  if (isPaymasterFailure(err)) {
    return false;
  }
  const msg = messageOf(err);
  return msg.includes("-32521") || msg.includes("execution reverted");
}
